import { MenuItem } from "@mui/material";
import ActionConfirmDialog from "components/ActionConfirmDialog/ActionConfirmDialog";
import { Employee } from "generated/graphql";
import useRestoreEmployee from "hooks/organization/employees/useRestoreEmployee";
import useConfirmationDialog from "hooks/useConfirmationDialog";
import { useCallback } from "react";

export default function Restore({ closeMenu, id }: { closeMenu: () => void; id: Employee["id"] }) {
  const [restoreEmployee, { isSuccess }] = useRestoreEmployee();

  const acceptFn = useCallback(async (): Promise<boolean> => {
    const result = await restoreEmployee({ variables: { id } });
    const success = isSuccess(result.data);
    if (success) {
      closeMenu();
    }
    return success;
  }, []);

  const cancelFn = useCallback(async () => {
    closeMenu();
    return true;
  }, []);

  const { open, setOpen, onAccept, onCancel } = useConfirmationDialog({
    acceptFn,
    cancelFn,
  });

  return (
    <>
      <ActionConfirmDialog
        open={open}
        setOpen={setOpen}
        handleAccept={onAccept}
        handleCancel={onCancel}
        title="Restore employee?"
        content="This employee will be restored and will appear in active employee lists and dropdowns again."
        acceptText="Restore"
      />
      <MenuItem onClick={() => setOpen(true)}>Restore</MenuItem>
    </>
  );
}
